import { useQuery } from '@tanstack/react-query';

import type {
  BlockComponentProps,
  MembershipCardBlockProps,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/content-blocks';
import { MembershipCardView } from '@art-of-hospitality-solutions-llc/ui-kit/components/content-blocks';

import service from '@Service';
import { unwrapList } from '@Utils/unwrap';

type SubscriptionTier = { id: string; title?: string };
type TiersResponse =
  | SubscriptionTier[]
  | { data: SubscriptionTier[]; meta?: Record<string, unknown> };

/**
 * Admin-only renderer for the `membershipCard` block. Presentation is the
 * kit's MembershipCardView (the same component the membership app renders,
 * so the preview cannot drift); this binding supplies a representative
 * tier — the app shows the viewing member's own, the editor has no member,
 * so the first real tier stands in. No linkComponent = inert lookalike.
 */
export default function MembershipCardPreview({ node }: BlockComponentProps) {
  const { title } = node.props as MembershipCardBlockProps;

  const { data } = useQuery<TiersResponse>({
    queryKey: ['subscription-tiers'],
    queryFn: async () =>
      (await service.getSubscriptionTiers()) as unknown as TiersResponse,
    staleTime: 60_000,
  });
  const tiers = unwrapList(data);
  const tierTitle = tiers[0]?.title || 'Member';

  return <MembershipCardView title={title} tierName={tierTitle} />;
}
